// extracted by mini-css-extract-plugin
export default {"selectionOptions":"SelectionOptions_selectionOptions__XdplW"};